import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxI18nService } from '@studiohyperdrive/ngx-i18n';

import { CypressTagDirective } from '@cjm/cypress/core';
import { VLoketAppRoutePaths } from '@cjm/shared/route-paths';
import { ButtonClasses, CJMContentComponent, LayoutContainerComponent, LinkComponent } from '@cjm/shared/ui/common';
import {
	AdviceDetailPageEntity,
	AdviceCardComponent,
	AssociationCardComponent,
	ProductGridItemComponent
} from '@cjm/v-loket/shared';

import { InTheSpotlightEntity } from '../../../data';
import { I18nKeys } from '../../../i18n';

@Component({
	selector: 'vloket-in-the-spotlight-section',
	templateUrl: 'in-the-spotlight-section.component.html',
	styleUrls: ['in-the-spotlight-section.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		CJMContentComponent,
		LayoutContainerComponent,
		AssociationCardComponent,
		ProductGridItemComponent,
		LinkComponent,
		AdviceCardComponent,
		TranslateModule,
		CypressTagDirective
	]
})
export class InTheSpotlightSectionComponent {
	@HostBinding('class.c-in-the-spotlight-section') private readonly hasPageClass: boolean = true;

	@Input() public advicePages: AdviceDetailPageEntity[];
	@Input() public spotlightItems: InTheSpotlightEntity;
	@Input() public adviceLoading: boolean;
	@Input() public spotlightItemsLoading: boolean;
	@Input() public isFavorite: boolean = false;
	@Input() public settingProductAsFavorite: string | number = null;

	/**
	 * setItemAsFavoriteClicked will emit an event when the "set as Favorite" button on an individual item is clicked.
	 */
	@Output() public setItemAsFavoriteClicked: EventEmitter<string | number> = new EventEmitter<string | number>();
	/**
	 * removeItemAsFavoriteClicked will emit an event when the "remove as Favorite" button on an individual item is clicked.
	 */
	@Output() public removeItemAsFavoriteClicked: EventEmitter<string | number> = new EventEmitter<string | number>();

	public readonly appRoutePaths: typeof VLoketAppRoutePaths = VLoketAppRoutePaths;
	public readonly buttonClasses: typeof ButtonClasses = ButtonClasses;
	public readonly i18nKeys: typeof I18nKeys = I18nKeys;

	constructor(public i18nService: NgxI18nService) {}
}
